import React, { Component } from "react";
import { Button } from "../components/Button";
import Input from "../components/Input";
import LimitedSelect from "../components/LimitedSelect";
import { operatorOperatingRights as operatingRights } from "../constants";
import "./SearchForm.css";
import { FormattedMessage } from "react-intl";
import MunicipalitySelect from "../components/MunicipalitySelect";

export class SearchForm extends Component {
  submitForm = event => {
    event.preventDefault();
    this.props.fetch(0);
  };

  render() {
    const {
      isFormValid,
      locale,
      searching,
      searchText,
      searchPersonText,
      selectedMunicipalities,
      selectedOperatingRights,
      updateMunicipalities,
      updateOperatingRights,
      updateSearchText,
      updateSearchPersonText,
      resetForm,
    } = this.props;


    return (
      <form className="searchForm" onSubmit={this.submitForm}>
        <div className="searchControls">
          <div className="searchInputContainer">
            <label htmlFor="searchText">
              <FormattedMessage id="common.company" />
            </label>
            <Input
              autoComplete="off"
              id="searchText"
              type="text"
              placeholder="operatorSearch.companySearchPlaceholder"
              value={searchText}
              onChange={updateSearchText}
            />
          </div>
          <div className="searchInputContainer">
            <label htmlFor="searchPersonText">
              <FormattedMessage id="common.person" />
            </label>
            <Input
              autoComplete="off"
              id="searchPersonText"
              type="text"
              placeholder="operatorSearch.personSearchPlaceholder"
              value={searchPersonText}
              onChange={updateSearchPersonText}
            />
          </div>
        </div>
        <div className="searchControls">
          <div className="searchInputContainer">
            <label>
              <FormattedMessage id="common.competencies" />
              <LimitedSelect
                id="selectedOperatingRights"
                onChange={updateOperatingRights}
                options={operatingRights[locale]}
                placeholder="operatorSearch.chooseCompetencies"
                value={selectedOperatingRights}
                maxSelections={5}
              />
            </label>
          </div>
          <div className="searchInputContainer">
            <label htmlFor="selectedMunicipalities">
              <FormattedMessage id="common.municipalities" />
            </label>
            <MunicipalitySelect
              selectedMunicipalities={selectedMunicipalities}
              onChange={updateMunicipalities}
              maxSelections={5}
              locale={locale}
            />
          </div>
        </div>
        <div className="searchButtonContainer">
          <div className="validatorMessage" role="alert">
            {!!!isFormValid() && (
              <FormattedMessage id="operatorSearch.inputError" />
            )}
          </div>
          <Button className="clearLink" onClick={resetForm}>
            <FormattedMessage id="common.clearForm" />
          </Button>
          <Button
            className="searchButton"
            type="submit"
            primary
            search
            disabled={searching || !isFormValid()}
          >
            <FormattedMessage id="common.search" />
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/OperatorSearch/SearchForm.js